import PropTypes from 'prop-types';
import React from 'react';
import Analytics from '@app/modules/analytics/index';

export default class Step extends React.PureComponent {
  componentDidMount() {
    this.trackAnalytics(this.props.analyticsEvent);
  }

  trackAnalytics = (analyticsEvent) => {
    if (!analyticsEvent) {
      return;
    }
    const { action, category, label } = analyticsEvent;
    Analytics.pushDataLayerEvent({
      action: action,
      category: category,
      label: label,
    });
  };

  render() {
    const { children } = this.props;
    return children;
  }
}

Step.propTypes = {
  analyticsEvent: PropTypes.shape({
    action: PropTypes.string,
    category: PropTypes.string,
    label: PropTypes.string,
  }),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  prevButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  nextButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};
